import {SEARCH_TERM_CAROUSEL_RESULTS_MIN} from '../../../utils/carouselLogUtils';

const getShowDestinationCarousel = (
    isLoadingOrRedirecting,
    typeaheadSuggestion,
    pageCount,
    resultCount,
    discoveryXploreFeeds,
    showDestinationRecommendations
) => {
    return (
        !isLoadingOrRedirecting &&
        !!(
            typeaheadSuggestion &&
            pageCount &&
            pageCount > 0 &&
            resultCount &&
            resultCount >= SEARCH_TERM_CAROUSEL_RESULTS_MIN &&
            discoveryXploreFeeds &&
            discoveryXploreFeeds.results.length > 0 &&
            showDestinationRecommendations
        )
    );
};

const getShowMabCarousels = (
    isLoadingOrRedirecting,
    pinnedPropertyListing,
    showDestinationCarousel
) => {
    return (
        !isLoadingOrRedirecting &&
        !pinnedPropertyListing &&
        !showDestinationCarousel
    );
};

export {getShowDestinationCarousel, getShowMabCarousels};
